var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    class: {
      'menu-list': _vm.type === 'pc',
      'menu_cards': _vm.type === 'mobile',
      '_mobile-menu-cards': _vm.type === 'mobile'
    }
  }, [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/journal'
    },
    attrs: {
      "to": "/journal"
    }
  }, [_vm._v("Журнал")])], 1), _vm.invType ? [_vm.invType === 1 ? [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/investments'
    },
    attrs: {
      "to": "/investments"
    }
  }, [_vm._v(" Инвестиции ")])], 1)] : [_c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/landing-invest'
    },
    attrs: {
      "to": "/landing-invest"
    }
  }, [_vm._v(" Инвестиции ")])], 1)]] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login-invest"
    }
  }, [_vm._v("Инвестиции")])], 1)], _c('li', [_c('router-link', {
    class: {
      active: _vm.section === '/consultations'
    },
    attrs: {
      "to": "/consultations"
    }
  }, [_vm._v("Консультации")])], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }